import { styled } from '../../../Utilities';
import { PersonaCoinBase } from './PersonaCoin.base';
import { getStyles } from './PersonaCoin.styles';
/**
 * PersonaCoin is used to render an individual's avatar and presence.
 */
export var PersonaCoin = styled(PersonaCoinBase, getStyles, undefined, {
    scope: 'PersonaCoin',
});
//# sourceMappingURL=PersonaCoin.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/office-ui-fabric-react/lib/components/Persona/PersonaCoin/PersonaCoin.js
// module id = 247
// module chunks = 0